
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";
import { API_TCase, TCase_Progress_Step } from "@/models/cases";

@Component
export default class Progress extends Vue {
  caseDashboardId = SMCases.tabId;

  init = false;

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get serviceReportStatus() {
    return SMCases.caseStatus;
  }

  get currentStepName() {
    return SMCases.caseStepName;
  }

  get currentStep() {
    const currentCase = SMCases.case as API_TCase;

    return (currentCase?.case_progress_step as unknown) as TCase_Progress_Step;
  }

  get title() {
    const { currentStepName } = this;

    if (!currentStepName) return "";

    const value = currentStepName;

    return value;
    //
    // let value = currentStepName;
    //
    // if (currentStep?.belongs_to_role) {
    //   value += `\n(${this.$root.$tc("belongsToRole." + currentStep?.belongs_to_role)})`;
    // }
    //
    // return value;
  }

  @Watch("serviceReportStatus")
  onServiceReportStatusUpdate(): void {
    this.getServiceProgress();
  }

  percent = 0;

  async getServiceProgress() {
    try {
      const { data } = await this.axios.get(
        API_ROUTES.PROGRESS_PERCENT(this.serviceId, this.caseDashboardId)
      );

      if (!data) return;

      this.percent = data.percent;
    } finally {
      this.init = true;
    }
  }

  created() {
    this.getServiceProgress();
  }

  activated() {
    this.getServiceProgress();
  }
}
